import React from 'react';

const OurTeam = () => {
  const linkedin="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/linkedin.png";
  const Gokul="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Gokul.png";
  const Ram="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Ram.png";
  const Manoj="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Manoj.png";
  return (
    <div className="py-12 px-6">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        {/* Header Section */}
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Our Leadership Team</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">Experienced leaders committed to your financial success.</p>
        </div>
        
        {/* Team Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8">
          {/* Ram Kalyan Medury */}
          <div className="flex flex-col items-center bg-white p-6 rounded-lg shadow-sm">
            <div className="mb-4 w-40 h-40 rounded-full overflow-hidden shadow-md">
              <img 
                src={Ram}
                alt="Ram Kalyan Medury"
                className="w-full h-full object-cover transform translate-y-2"
              />
            </div>
            
            <h3 className="text-xl font-medium text-gray-800 mb-1">Ram Medury</h3>
            <p className="text-blue-600 font-medium mb-3">Founder & CEO</p>
            
            <p className="text-sm text-gray-600 mb-4">
              Ram has scaled many fintech businesses during his career. Previously, he served as CIO at ICICI-L, Poonawalla Fincorp, and as Fintech Head at Infosys Hyderabad. He holds an MBA from IIM Bangalore, MTech from IIT Hyderabad, and a BS in Computer Science.
            </p>
            
            <a 
              href="https://www.linkedin.com/in/rammedury/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto"
            >
              <img src={linkedin} alt="LinkedIn" className="w-4 h-4" />
            </a>
          </div>

          {/* Manoj Trivedi */}
          <div className="flex flex-col items-center bg-white p-6 rounded-lg shadow-sm">
            <div className="mb-4 w-40 h-40 rounded-full overflow-hidden shadow-md">
              <img 
                src={Manoj}
                alt="Manoj Trivedi"
                className="w-full h-full object-cover transform translate-y-2"
              />
            </div>
            
            <h3 className="text-xl font-medium text-gray-800 mb-1">Manoj Trivedi</h3>
            <p className="text-blue-600 font-medium mb-3">Director</p>
            
            <p className="text-sm text-gray-600 mb-4">
              Manoj brings deep Research/IA experience spanning over three decades. He is a FinTech Leader and Author with an MBA from IIM Bangalore. He achieved distinction as a CA Ranker and holds credentials from ICFAI and ICWAI.
            </p>
            
            <a 
              href="https://www.linkedin.com/in/manoj-trivedi-a517b014/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto"
            >
              <img src={linkedin} alt="LinkedIn" className="w-4 h-4" />
            </a>
          </div>

          {/* Gokul Sudhakaran */}
          <div className="flex flex-col items-center bg-white p-6 rounded-lg shadow-sm">
            <div className="mb-4 w-40 h-40 rounded-full overflow-hidden shadow-md">
              <img 
                src={Gokul}
                alt="Gokul Sudhakaran"
                className="w-full h-full object-cover transform translate-y-2"
              />
            </div>
            
            <h3 className="text-xl font-medium text-gray-800 mb-1">Gokul Sudhakaran</h3>
            <p className="text-blue-600 font-medium mb-3">Head of Sales</p>
            
            <p className="text-sm text-gray-600 mb-4">
              Gokul is a seasoned sales leader in Wealth Management. He is a Certified Private Wealth Banker with an MBA from IMT Ghaziabad. With over 12 years of experience at MO Wealth and ICICI Bank, he has successfully managed HNI assets exceeding 1000+ crores.
            </p>
            
            <a 
              href="https://www.linkedin.com/in/gokulsudhakaran/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto"
            >
              <img src={linkedin} alt="LinkedIn" className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;